import TableCommonHook from '@op/components/TableCommonHook';
import React, { useMemo } from 'react';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import {
  ConfigItemType,
  coreKeyMetricsConfig,
  keyMetricObj,
} from '../constants';
import useLanguage from '@op/hooks/useLanguage';
import { Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import { DBO_TM } from '@op/utils/format';

interface KeyMetricsTableProps {
  loading: boolean;
  data: any[];
  event: { onClick: (cvm: any) => void };
}

export default function KeyMetricsTable({
  loading,
  data,
  event,
}: KeyMetricsTableProps) {
  const { formatMessage } = useLanguage();
  const { columns, sortColumns } = useMemo(() => {
    const sortList: Array<string> = [];
    const list = coreKeyMetricsConfig.map(
      ({
        align = 'right',
        key,
        text,
        hasSort,
        format,
        getRingRatioProps,
        hasDetail,
        width = 120,
        isPercentage,
        isText,
      }: ConfigItemType) => {
        if (hasSort) {
          sortList.push(key);
        }

        return {
          key,
          header: formatMessage(text),
          align,
          width,
          render: (cvm: any) => {
            const value = cvm[key];
            const { format: itemFormat } = keyMetricObj[cvm.metric];

            const func = format || itemFormat;
            const showValue = isPercentage ? value : func(value);


            if (isText) {
              return formatMessage(showValue);
            }

            if (!getRingRatioProps) {
              return showValue;
            }

            const ringRatioProps = getRingRatioProps(cvm);
            return (
              <div className="dbo-key-metric-box">
                {hasDetail ? (
                  <Bubble
                    arrowPointAtCenter
                    content={formatMessage('Click to view channel & language distribution')}
                  >
                    <div onClick={() => event?.onClick?.(cvm)}>
                      <SvgIcon
                        className="dbo-key-metric-icon"
                        type="view-details-icon"
                      />
                    </div>
                  </Bubble>
                ) : (
                  <div className="dbo-item-placeholder"></div>
                )}
                <RingRatioBubble
                  {...ringRatioProps}
                  formateDate={DBO_TM.formatFunc('weekly')}
                  formateValue={itemFormat}
                >
                  <PercentageItem percentage={showValue}></PercentageItem>
                </RingRatioBubble>
              </div>
            );
          },
        };
      },
    );

    return {
      columns: list,
      sortColumns: sortList,
    };
  }, [event, formatMessage]);

  return (
    <TableCommonHook
      records={data}
      className="dbo-key-metric-table-wrapper"
      total={data?.length || 0}
      columns={columns}
      sortType="local"
      loading={loading}
      hasPageable={false}
      bordered="all"
      sortColumns={sortColumns}
      minWidth={1230}
    ></TableCommonHook>
  );
}
